import { render, staticRenderFns } from "./queryPrintRecordList.vue?vue&type=template&id=246545ab"
import script from "./queryPrintRecordList.vue?vue&type=script&lang=js"
export * from "./queryPrintRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports